import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/components/CommunityTiles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/components/HeroLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/components/LiveCounts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/components/LivePlayers.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/components/Reveal.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/components/ScrollParallax.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/components/sections/Stats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/components/SiteHeader.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/components/Starfield.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/node_modules/next/dist/client/image-component.js");
